export const useNetworkStatus = () => {
  const online = useState<boolean>("app-network-online", () => true);

  onMounted(() => {
    online.value = navigator.onLine;
    const setOnline = () => (online.value = true);
    const setOffline = () => (online.value = false);
    window.addEventListener("online", setOnline);
    window.addEventListener("offline", setOffline);
    onUnmounted(() => {
      window.removeEventListener("online", setOnline);
      window.removeEventListener("offline", setOffline);
    });
  });

  return { online: readonly(online) };
};
